import UserService from "@/services/api/user";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const name = "user";

const initialState = {
  users: [],
  totalUsers: 0,
  isFetching: false,
  totalAppSettings: 0,
  appSettings: [],
};

export const getUsers = createAsyncThunk(
  `${name}/getUsers`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await UserService.getUsers(params);
      return data.data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAppSetting = createAsyncThunk(
  `${name}/getAppSetting`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await UserService.getAppSetting(params);
      console.log(data);
      return data.data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isFetching = false;
        state.users = action.payload.rows;
        state.totalUsers = action.payload.count;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isFetching = false;
        console.error("Failed to fetch users:", action.payload);
      });

    builder
      .addCase(getAppSetting.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getAppSetting.fulfilled, (state, action) => {
        state.isFetching = false;
        state.appSettings = action.payload.rows;
        state.totalAppSettings = action.payload.count;
      })
      .addCase(getAppSetting.rejected, (state, action) => {
        state.isFetching = false;
        console.error("Failed to fetch app settings:", action.payload);
      });
  },
});

export default userSlice.reducer;
export const { clear } = userSlice.actions;
